( function( $ ) {
  $( document ).on( 'click', '.npx-collapsible-header a', function( event ) {
    var elementTarget = $( this ).attr( 'href' ),
    elementOffset = $( this ).outerHeight() + 5;

    setTimeout( function() {
      myScroll.scrollToElement( elementTarget, 1000, null, -elementOffset );
    }, 1500)
  });
})( jQuery );